const ProductModel = {
    find: (productId, products = []) => {
        const radix = 10;
        return products.find((product) => parseInt(product.id, radix) === parseInt(productId, radix));
    },

    findBySlug: (productSlug, products = []) => products.find((product) => product.attributes.slug === productSlug),

    variants: (variantIds, productsList = {}) => productsList.included.filter((item) => item.type === 'variant' && variantIds.indexOf(item.id) !== -1),

    masterVariant: (id, productsList = {}) => productsList.included.find((item) => item.type === 'variant' && item.id === id),

    images: (imageIds, productsList = {}) => productsList.included.filter((item) => item.type === 'image' && imageIds.indexOf(item.id) !== -1),

    data_extra_types: (extraDataTypeIds, productsList = {}) => productsList.included.filter((item) => item.type === 'data_extra_type' && extraDataTypeIds.indexOf(item.id) !== -1),

    properties: (propertyIds, productsList = {}) => {},

    filterUniqueProducts: (products) => {
        const productsFilters = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const product of products) {
            const filterCondition = productsFilters.findIndex((item) => item.id === product.id) === -1;
            if (filterCondition) {
                productsFilters.push(product);
            }
        }
        return productsFilters;
    },
};

export default ProductModel;



/** WEBPACK FOOTER **
 ** ./src/services/product-model.js
 **/